import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "frame", "title"]

  connect() {
    this.frameTarget.addEventListener("turbo:frame-load", this.open.bind(this))
    this.keydownHandler = (e) => { if (e.key === "Escape") this.close() }
    window.addEventListener("keydown", this.keydownHandler)
  }

  disconnect() {
    window.removeEventListener("keydown", this.keydownHandler)
  }

  open() {
    this.titleTarget.textContent = this.frameTarget.querySelector("[data-side-sheet-title]")?.dataset.sideSheetTitle ?? ""
    this.panelTarget.classList.remove("translate-x-full")
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    document.body.classList.remove("overflow-hidden")
    setTimeout(() => { this.frameTarget.innerHTML = "" }, 300)
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }
}
